import { useUrlBuilder } from '@/composables/url-builder'

export function getEcommerceUrl (env: Partial<ImportMetaEnv>): string {
  const url = env.VUE_APP_ECOMMERCE_URL ?? window.location.origin.replace('://', '://store.')

  return useUrlBuilder(url).removeTrailingSlash().build()
}
